<app-header></app-header>
<app-navbar></app-navbar>

<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">

        <div class="row">
            <form [formGroup]="validateTuitionCalcForm" (ngSubmit)="onSubmit()" class="needs-validation" novalidate>
                <div class="row">

                    <div class="separator mt-5"></div>
                    <h2><label class="form-label textformat">{{ 'tuition-calc.infoGeneral'
                            | translate }}</label>
                    </h2>
                    @let controlSystemCode = validateTuitionCalcForm.get('externalSystemCode');
                    <!-- ExternalSytemCode-->
                    <div class="col-auto  mb-3">
                        <label for="externalSystemCode" class="form-label">
                            {{ 'tuition-calc.extSystemCode' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="externalSystemCode" type="text" class="form-control "
                            formControlName="externalSystemCode"
                            [class.is-invalid]="controlSystemCode?.invalid && (controlSystemCode?.touched || formSubmit)"
                            [class.is-valid]="controlSystemCode?.valid && (controlSystemCode?.touched || formSubmit)" />
                        @if (controlSystemCode?.invalid && (controlSystemCode?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlTr = validateTuitionCalcForm.get('idUniqueTransactionExternalSystem');
                    <!-- idUniqueTransactionExternalSystem-->
                    <div class="col-auto mb-3">
                        <label class="form-label" for="idUniqueTransactionExternalSystem">{{
                            'tuition-calc.idUniqueTransactionExternalSystem' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="idUniqueTransactionExternalSystem" type="text" class="form-control "
                            formControlName="idUniqueTransactionExternalSystem"
                            [class.is-invalid]="controlTr?.invalid && (controlTr?.touched || formSubmit)"
                            [class.is-valid]="controlTr?.valid && (controlTr?.touched || formSubmit)" />
                        @if (controlTr?.invalid && (controlTr?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlStudent = validateTuitionCalcForm.get('idpStudent');
                    <!-- idpStudent-->
                    <div class="col-auto col-md-1 mb-3">
                        <label class="form-label" for="idpStudent">{{ 'launcher.idp' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="idpStudent" type="text" class="form-control " formControlName="idpStudent"
                            (input)="validateNumericInput($event)"
                            [class.is-invalid]="controlStudent?.invalid && (controlStudent?.touched || formSubmit)"
                            [class.is-valid]="controlStudent?.valid && (controlStudent?.touched || formSubmit)" />
                        @if (controlStudent?.invalid && (controlStudent?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlDate = validateTuitionCalcForm.get('referenceDate');
                    <!-- referenceDate-->
                    <div class="col-auto mb-3">
                        <label class="form-label" for="referenceDate">{{ 'launcher.date' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="referenceDate" type="date" class="form-control" formControlName="referenceDate"
                            [class.is-invalid]="controlDate?.invalid && (controlDate?.touched || formSubmit)"
                            [class.is-valid]="controlDate?.valid && (controlDate?.touched || formSubmit)" />
                        @if (controlDate?.invalid && (controlDate?.touched || formSubmit)) {
                        }
                        @if (controlDate?.invalid && (controlDate?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlTypo = validateTuitionCalcForm.get('typology');
                    <!-- typology -->
                    <div class="col-md-1 mb-3">
                        <label for="typology" class="form-label">
                            {{ 'launcher.typology' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="typology" class="form-select" formControlName="typology"
                            [class.is-invalid]="controlTypo?.invalid && (controlTypo?.touched || formSubmit)"
                            [class.is-valid]="controlTypo?.valid && (controlTypo?.touched || formSubmit)">
                            <option value="P">P - {{ 'launcher.own' | translate }}</option>
                            <!--<option value="O">O - {{ 'launcher.official' | translate }}</option>-->
                        </select>
                        @if (controlTypo?.invalid && (controlTypo?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlMatShipIndic= validateTuitionCalcForm.get('materialShippingIndicator');
                    <!-- materialShippingIndicator-->
                    <div class="col-auto mb-3">
                        <label for="materialShippingIndicator" class="form-label">
                            {{ 'tuition-calc.materialShippingIndicator' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="materialShippingIndicator" class="form-select"
                            formControlName="materialShippingIndicator"
                            [class.is-invalid]="controlMatShipIndic?.invalid && (controlMatShipIndic?.touched || formSubmit)"
                            [class.is-valid]="controlMatShipIndic?.valid && (controlMatShipIndic?.touched || formSubmit)">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                        @if (controlMatShipIndic?.invalid && (controlMatShipIndic?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlTypology = validateTuitionCalcForm.get('typeOfRegistration');
                    <!-- typeRegistrationProcess -->
                    <div class="col-auto mb-3">
                        <label for="typeOfRegistration" class="form-label">
                            {{ 'tuition-calc.typeRegistrationProcess' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="typeOfRegistration" class="form-select" formControlName="typeOfRegistration"
                            [class.is-invalid]="controlTypology?.invalid && (controlTypology?.touched || formSubmit)"
                            [class.is-valid]="controlTypology?.valid && (controlTypology?.touched || formSubmit)">
                            <option value="P">P - {{ 'tuition-calc.program' | translate }}</option>
                            <option value="S">S - {{ 'tuition-calc.subject' | translate }}</option>
                        </select>
                        @if (controlTypology?.invalid && (controlTypology?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>


                    @let controlRm= validateTuitionCalcForm.get('rateModelCode');
                    <!-- rateModel-->
                    <div class="col-auto mb-3">
                        <label for="rateModelCode" class="form-label">
                            {{ 'launcher.rateModel' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="rateModelCode" class="form-select" formControlName="rateModelCode"
                            [class.is-invalid]="controlRm?.invalid && (controlRm?.touched || formSubmit)"
                            [class.is-valid]="controlRm?.valid && (controlRm?.touched || formSubmit)">
                            @for (rm of this.filteredRateModels; track $index) {
                            <option [value]="rm.idRateModel">{{ rm.idRateModel }} - {{ rm.codeRateModel }} - {{
                                rm.rateModelTraductionDto?.[0]?.shortDescription }}</option>
                            }
                        </select>
                        @if (controlRm?.invalid && (controlRm?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>


                    <!-- DESPLEGABLES DE SELECCIÓN -->
                    <!-- ######################### -->
                    <div class="separator mt-5"></div>
                    <h2><label class="form-label textformat">{{
                            'tuition-calc.patternModiAndCancellAndMore' | translate
                            }}</label>
                    </h2>

                    <div class="col-auto mb-3">
                        <label for="selectionPayment" class="form-label">
                            {{ 'tuition-calc.selectPayment' | translate }}
                        </label>
                        <select id="selectionPayment" class="form-select" formControlName="selectionPayment">
                            <option [value]="1">{{ 'tuition-calc.payStudent' | translate }}</option>
                            <option [value]="2">{{ 'tuition-calc.payCompany' | translate }}</option>
                            <option [value]="3">{{ 'tuition-calc.payStudentAndCompany' | translate }}</option>
                        </select>
                    </div>


                    <div class="col-auto mb-3">
                        <label for="patternModification" class="form-label">
                            {{ 'tuition-calc.selectionPattModifi' | translate }}
                        </label>
                        <select id="patternModification" class="form-select" formControlName="patternModification">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                    </div>


                    <div class="col-auto mb-3">
                        <label for="patternCancellation" class="form-label">
                            {{ 'tuition-calc.selectionPattCancell' | translate }}
                        </label>
                        <select id="patternCancellation" class="form-select" formControlName="patternCancellation">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                    </div>

                    <div class="col-auto mb-3">
                        <label for="taxAdminOptional" class="form-label">
                            {{ 'tuition-calc.taxAdminOptioanl' | translate }}
                        </label>
                        <select id="taxAdminOptional" class="form-select" formControlName="taxAdminOptional">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                    </div>

                    <div class="col-auto mb-3">
                        <label for="discountPromotionalSelect" class="form-label">
                            {{ 'tuition-calc.infoDiscountPromotional' | translate }}
                        </label>
                        <select id="discountPromotionalSelect" class="form-select"
                            formControlName="discountPromotionalSelect">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                    </div>

                    <div class="col-auto mb-3">
                        <label for="discountSelect" class="form-label">
                            {{ 'tuition-calc.selctDiscountSelct' | translate }}
                        </label>
                        <select id="discountSelect" class="form-select" formControlName="discountSelect">
                            <option [value]="'S'">{{ 'launcher.learningResourcesYes' | translate }}</option>
                            <option [value]="'N'">{{ 'launcher.learningResourcesNo' | translate }}</option>
                        </select>
                    </div>

                    <!-- ## BLOQUE COMPAÑIA -->
                    <!-- ################## -->
                    <div class="row" [hidden]="!this.isPayCompany">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.companyInfo' | translate }}</label>
                        </h2>
                        @let controlPper = validateTuitionCalcForm.get('companyPaymentPercentage');
                        <!-- companyPaymentPercentage-->
                        <div class="col-auto mb-3">
                            <label class="form-label" for="companyPaymentPercentage">
                                {{ 'tuition-calc.companyPaymentPercentage' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="companyPaymentPercentage" type="text" class="form-control"
                                formControlName="companyPaymentPercentage"
                                [class.is-invalid]="controlPper?.invalid && (controlPper?.touched || formSubmit)"
                                [class.is-valid]="controlPper?.valid && (controlPper?.touched || formSubmit)" />
                            @if (controlPper?.invalid && (controlPper?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        @let controlCfix = validateTuitionCalcForm.get('companyFixedAmount');
                        <!-- companyFixedAmount-->
                        <div class="col-auto mb-3">
                            <label class="form-label" for="companyFixedAmount">
                                {{ 'tuition-calc.companyFixedAmount' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="companyFixedAmount" type="text" class="form-control"
                                formControlName="companyFixedAmount"
                                [class.is-invalid]="controlCfix?.invalid && (controlCfix?.touched || formSubmit)"
                                [class.is-valid]="controlCfix?.valid && (controlCfix?.touched || formSubmit)" />
                            @if (controlCfix?.invalid && (controlCfix?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        <!-- selectedCofrosCompanyPaymentMethodCode-->
                        @let controlSelCofrComp = validateTuitionCalcForm.get('selectedCofrosCompanyPaymentMethodCode');
                        <div class="col-auto mb-3">
                            <label class="form-label" for="selectedCofrosCompanyPaymentMethodCode">
                                {{ 'tuition-calc.selectedCofrosCompanyPaymentMethodCode' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="selectedCofrosCompanyPaymentMethodCode" type="text" class="form-control"
                                formControlName="selectedCofrosCompanyPaymentMethodCode"
                                [class.is-invalid]="controlSelCofrComp?.invalid && (controlSelCofrComp?.touched || formSubmit)"
                                [class.is-valid]="controlSelCofrComp?.valid && (controlSelCofrComp?.touched || formSubmit)" />
                            @if (controlSelCofrComp?.invalid && (controlSelCofrComp?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        <!-- numberInstallmentsCompanyPaymentMethod-->
                        @let controlNumbInsCompa =
                        validateTuitionCalcForm.get('numberInstallmentsCompanyPaymentMethod');
                        <div class="col-auto mb-3">
                            <label class="form-label" for="numberInstallmentsCompanyPaymentMethod">
                                {{ 'tuition-calc.numberInstallmentsCompanyPaymentMethod' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="numberInstallmentsCompanyPaymentMethod" type="text" class="form-control"
                                formControlName="numberInstallmentsCompanyPaymentMethod"
                                (input)="validateNumericInput($event)"
                                [class.is-invalid]="controlNumbInsCompa?.invalid && (controlNumbInsCompa?.touched || formSubmit)"
                                [class.is-valid]="controlNumbInsCompa?.valid && (controlNumbInsCompa?.touched || formSubmit)" />
                            @if (controlNumbInsCompa?.invalid && (controlNumbInsCompa?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        <!-- firstInstallmentPercentageCompany-->
                        @let controlFistInsCompa = validateTuitionCalcForm.get('firstInstallmentPercentageCompany');
                        <div class="col-auto mb-3">
                            <label class="form-label" for="firstInstallmentPercentageCompany">
                                {{ 'tuition-calc.firstInstallmentPercentageCompany' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="firstInstallmentPercentageCompany" type="text" class="form-control"
                                formControlName="firstInstallmentPercentageCompany"
                                (input)="validateNumericInput($event)"
                                [class.is-invalid]="controlFistInsCompa?.invalid && (controlFistInsCompa?.touched || formSubmit)"
                                [class.is-valid]="controlFistInsCompa?.valid && (controlFistInsCompa?.touched || formSubmit)" />
                            @if (controlFistInsCompa?.invalid && (controlFistInsCompa?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>


                    </div>

                    <!-- ## BLOQUE ESTUDIANTE -->
                    <!-- #################### -->
                    <div class="row" [hidden]="!this.isPayStudent">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.studentInfo' | translate }}</label>
                        </h2>

                        @let controlSelCofStudent =
                        validateTuitionCalcForm.get('selectedCofrosStudentPaymentMethodCode');
                        <!-- selectedCofrosStudentPaymentMethodCode-->
                        <div class="col-auto mb-3">
                            <label class="form-label" for="selectedCofrosStudentPaymentMethodCode">
                                {{ 'tuition-calc.selectedCofrosStudentPaymentMethodCode' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="selectedCofrosStudentPaymentMethodCode" type="text" class="form-control"
                                formControlName="selectedCofrosStudentPaymentMethodCode"
                                [class.is-invalid]="controlSelCofStudent?.invalid && (controlSelCofStudent?.touched || formSubmit)"
                                [class.is-valid]="controlSelCofStudent?.valid && (controlSelCofStudent?.touched || formSubmit)" />
                            @if (controlSelCofStudent?.invalid && (controlSelCofStudent?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>


                        @let controlNumStudentPay =
                        validateTuitionCalcForm.get('numberInstallmentsStudentPaymentMethod');
                        <!-- numberInstallmentsStudentPaymentMethod-->
                        <div class="col-auto mb-3">
                            <label class="form-label" for="numberInstallmentsStudentPaymentMethod">
                                {{ 'tuition-calc.numberInstallmentsStudentPaymentMethod' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="numberInstallmentsStudentPaymentMethod" type="text" class="form-control"
                                formControlName="numberInstallmentsStudentPaymentMethod"
                                (input)="validateNumericInput($event)"
                                [class.is-invalid]="controlNumStudentPay?.invalid && (controlNumStudentPay?.touched || formSubmit)"
                                [class.is-valid]="controlNumStudentPay?.valid && (controlNumStudentPay?.touched || formSubmit)" />
                            @if (controlNumStudentPay?.invalid && (controlNumStudentPay?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>


                        @let controlFirstInstaStudent =
                        validateTuitionCalcForm.get('firstInstallmentPercentageStudent');
                        <!-- firstInstallmentPercentageStudent-->
                        <div class="col-auto mb-3">
                            <label class="form-label" for="firstInstallmentPercentageStudent">
                                {{ 'tuition-calc.firstInstallmentPercentageStudent' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="firstInstallmentPercentageStudent" type="text" class="form-control"
                                formControlName="firstInstallmentPercentageStudent"
                                (input)="validateNumericInput($event)"
                                [class.is-invalid]="controlFirstInstaStudent?.invalid && (controlFirstInstaStudent?.touched || formSubmit)"
                                [class.is-valid]="controlFirstInstaStudent?.valid && (controlFirstInstaStudent?.touched || formSubmit)" />
                            @if (controlFirstInstaStudent?.invalid && (controlFirstInstaStudent?.touched || formSubmit))
                            {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                    </div>

                    <!-- ## PATRONES DE MODIFICACIÓN -->
                    <!-- ########################### -->
                    <div class="row" [hidden]="!isPatternModification">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.modification' | translate }}</label>
                        </h2>

                        <div class="row">
                            <!-- behaviourPatternModificationCode -->
                            <div class="col-auto mb-3" formGroupName="dataForEnrolmentModification">
                                <label class="form-label">
                                    {{ 'tuition-calc.behaviourPatternModificationCode' | translate }}
                                </label>
                                <span class="text-danger">*</span>

                                <select class="form-select" [class.is-invalid]="
                                behaviourPatterModification?.hasError('required') &&
                                behaviourPatterModification?.invalid && (behaviourPatterModification?.touched ||
                                 formSubmit)" formControlName="behaviourPatternModificationCode">
                                    @for (patModif of this.patternModificationReponse; track $index) {
                                    <option [value]="patModif.idEnrollmentBehaviorPatternModification">
                                        {{patModif.shortDescription}}
                                    </option>

                                    }
                                </select>
                                @if (behaviourPatterModification?.invalid && (behaviourPatterModification?.touched ||
                                formSubmit)) {
                                <div class="invalid-feedback">
                                    {{ 'launcher.requiredField' | translate }}
                                </div>
                                }
                            </div>

                            <!-- numberTimesModificationFeeAppliedBefore -->
                            <div class="col-auto mb-3">
                                <label class="form-label" for="numberTimesModificationFeeAppliedBefore">
                                    {{ 'tuition-calc.numberTimesModification' | translate }}
                                    <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="numberTimesModificationFeeAppliedBefore"
                                    [class.is-invalid]="
                                    numberTimesModification?.hasError('required') &&
                                    numberTimesModification?.invalid && (numberTimesModification?.touched || formSubmit)"
                                    formControlName="numberTimesModificationFeeAppliedBefore" />
                                @if (numberTimesModification?.invalid && (numberTimesModification?.touched ||
                                formSubmit)) {
                                <div class="invalid-feedback">
                                    {{ 'launcher.requiredField' | translate }}
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <!-- ## PATRONES DE CANCELACÍON -->
                    <!-- ########################## -->

                    <div class="row" [hidden]="!isPatternCancellation">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.cancellation' | translate }}</label>
                        </h2>

                        <div class="row">
                            <!-- behaviourPatternCancelationCode -->
                            <div class="col-auto mb-3" formGroupName="dataForEnrolmentCancelation">
                                <label class="form-label">
                                    {{ 'tuition-calc.behaviourPatternModificationCode' | translate }}
                                </label>
                                <span class="text-danger">*</span>

                                <select class="form-select" formControlName="behaviourPatternCancelationCode">
                                    @for (patCancell of this.patternCancellationResponse; track $index) {
                                    <option [value]="patCancell.idEnrollmentCancellationPattern">
                                        {{patCancell.shortDescription}}
                                    </option>
                                    }
                                </select>

                                @if (behaviourPatterModification?.invalid && (behaviourPatterModification?.touched ||
                                formSubmit)) {
                                <div class="invalid-feedback">
                                    {{ 'launcher.requiredField' | translate }}
                                </div>
                                }
                            </div>
                        </div>

                    </div>

                    <!-- ## BLOQUE PARA LOS PROGRAMAS -->
                    <!-- ############################ -->
                    <div [hidden]="!this.isProgram">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.listProgram' | translate }}</label>
                        </h2>

                        <div id="block-program" class="row" formArrayName="listProgramOfRegistration">
                            @for (listPr of listProgramsArray.controls; let i= $index; track $index) {
                            <div class="row" [formGroupName]="i">

                                @let controlIdProd = validateTuitionCalcForm.get('idProduct');
                                <!-- idProduct -->
                                <div class="col-auto mb-3">
                                    <label class="form-label" for="idProduct">{{ 'tuition-calc.idProduct' | translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control" formControlName="idProduct"
                                        [class.is-invalid]="controlIdProd?.invalid && (controlIdProd?.touched || formSubmit)"
                                        [class.is-valid]="controlIdProd?.valid && (controlIdProd?.touched || formSubmit)" />
                                    @if (controlIdProd?.invalid && (controlIdProd?.touched || formSubmit)) {
                                    <div class="invalid-feedback">
                                        {{ 'launcher.requiredField' | translate }}
                                    </div>
                                    }
                                </div>

                                <!-- academicRateType -->
                                <div class="col-auto mb-3">
                                    <fieldset disabled>
                                        <label for="academicType" class="form-label text-nowrap">
                                            {{ 'launcher.academic' | translate }} <span class="text-danger">*</span>
                                        </label>
                                        <input id="academicType" type="text" class="form-control" value="N - Normal"
                                            readonly>
                                    </fieldset>
                                </div>

                                <!--numberTimesProgramRegistered -->
                                <div class="col-auto mb-3">
                                    <label class="form-label" for="numberTimesProgramRegistered">{{
                                        'tuition-calc.numberTimesProgramRegistered' | translate
                                        }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control "
                                        formControlName="numberTimesProgramRegistered"
                                        (input)="validateNumericInput($event)" />
                                </div>

                                <!-- numberCreditsForProgram 
                                <div class="col-auto mb-3">
                                    <label class="form-label" for"numberCreditsForProgram">{{ 'tuition-calc.numberCreditsForProgram' | translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control " formControlName="numberCreditsForProgram"
                                        (input)="validateNumericInput($event)" />
                                </div>
                                -->
                                <!-- numberCreditsForProgramRegistration -->
                                <div class="col-auto mb-3">
                                    <label class="form-label" for="numberCreditsForProgramRegistration">{{
                                        'tuition-calc.numberCreditsForProgramRegistration' |
                                        translate
                                        }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control "
                                        formControlName="numberCreditsForProgramRegistration"
                                        (input)="validateNumericInput($event)" />
                                </div>

                                <!-- numberCreditsForProgramRegistrationCurrentPeriod -->
                                <div class="col-auto mb-3" [hidden]="!isPatternCancellation">
                                    <label class="form-label" for="numberCreditsForProgramRegistrationCurrentPeriod">{{
                                        'tuition-calc.numberCreditsForProgramRegistrationCurrentPeriod'
                                        |
                                        translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control "
                                        formControlName="numberCreditsForProgramRegistrationCurrentPeriod"
                                        [class.is-invalid]="numberCreditsForProgramRegistrationCurrentPeriod?.hasError('required') &&
                                        numberCreditsForProgramRegistrationCurrentPeriod?.invalid && (numberCreditsForProgramRegistrationCurrentPeriod?.touched ||
                                        formSubmit)" (input)="validateNumericInput($event)" />
                                    @if (numberCreditsForProgramRegistrationCurrentPeriod?.invalid &&
                                    (numberCreditsForProgramRegistrationCurrentPeriod?.touched ||
                                    formSubmit)) {
                                    <div class="invalid-feedback">
                                        {{ 'launcher.requiredField' | translate }}
                                    </div>
                                    }
                                </div>

                                <!-- numberCreditsForProgramRegistrationCompleted -->
                                <div class="col-auto mb-3" [hidden]="!isPatternCancellation">
                                    <label class="form-label" for="numberCreditsForProgramRegistrationCompleted">{{
                                        'tuition-calc.numberCreditsForProgramRegistrationCompleted'
                                        |
                                        translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control "
                                        formControlName="numberCreditsForProgramRegistrationCompleted"
                                        (input)="validateNumericInput($event)" [class.is-invalid]="numberCreditsForProgramRegistrationCompleted?.hasError('required') &&
                                        numberCreditsForProgramRegistrationCompleted?.invalid && (numberCreditsForProgramRegistrationCompleted?.touched ||
                                        formSubmit)" (input)="validateNumericInput($event)" />
                                    @if (numberCreditsForProgramRegistrationCompleted?.invalid &&
                                    (numberCreditsForProgramRegistrationCompleted?.touched ||
                                    formSubmit)) {
                                    <div class="invalid-feedback">
                                        {{ 'launcher.requiredField' | translate }}
                                    </div>
                                    }
                                </div>

                                <!-- numberCreditsCancelled -->
                                <div class="col-auto mb-3" [hidden]="!isPatternModification">
                                    <label class="form-label" for="numberCreditsCancelled">{{
                                        'tuition-calc.numberCreditsCancelled' | translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control " formControlName="numberCreditsCancelled"
                                        [class.is-invalid]="numberCreditsCancelled?.invalid && (numberCreditsCancelled?.touched ||formSubmit)"
                                        (input)="validateNumericInput($event)" />
                                    @if (numberCreditsCancelled?.invalid && (numberCreditsCancelled?.touched ||
                                    formSubmit)) {
                                    <div class="invalid-feedback">
                                        {{ 'launcher.requiredField' | translate }}
                                    </div>
                                    }
                                </div>

                                @let controlLerResou =
                                validateTuitionCalcForm.get('listProgramOfRegistration.chargeLearningResourcesBecauseOfAcademicReasons');
                                <!-- chargeLearningResourcesBecauseOfAcademicReasons -->
                                <div class="col-auto mb-3">
                                    <label class="form-label">{{
                                        'tuition-calc.chargeLearningResourcesBecauseOfAcademicReasons'
                                        |
                                        translate }}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <select class="form-select"
                                        formControlName="chargeLearningResourcesBecauseOfAcademicReasons"
                                        [class.is-invalid]="controlLerResou?.invalid && (controlLerResou?.touched || formSubmit)"
                                        [class.is-valid]="controlLerResou?.valid && (controlLerResou?.touched || formSubmit)">
                                        <option [value]="'S'"> {{ 'launcher.learningResourcesYes' | translate }}
                                        </option>
                                        <option [value]="'N'"> {{ 'launcher.learningResourcesNo' | translate }}</option>
                                    </select>
                                    @if (controlLerResou?.invalid && (controlLerResou?.touched || formSubmit)) {
                                    <div class="invalid-feedback">
                                        {{ 'launcher.requiredField' | translate }}
                                    </div>
                                    }
                                </div>

                                <div class="col-auto  mb-3">
                                    <fieldset disabled>
                                        <label for="typeLearning" class="form-label">
                                            {{ 'launcher.typeLearning' | translate }} <span class="text-danger">*</span>
                                        </label>
                                        <input id="typeLearning" type="text" class="form-control"
                                            [value]="'launcher.typeLearningValue' | translate" readonly />
                                    </fieldset>
                                </div>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- ## BLOQUE PARA LAS ASIGNATURAS -->
                    <!-- ############################## -->
                    <div [hidden]="!this.isSubject">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.listSubjects' | translate }}</label>
                        </h2>
                        <div class="row" id="subject">

                            <div class="alert alert-primary" role="alert">
                                FALTA IMPLEMENTAR
                            </div>

                        </div>
                    </div>

                    <!-- ## BLOQUE PARA LAS TASAS ADMINISTRATIVAS OPCIONALES -->
                    <!-- ################################################### -->
                    <div class="row" [hidden]="!isTaxAdminOptional">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.listAdministrativeOptional' |
                                translate
                                }}</label>
                        </h2>
                        <div class="col-auto mb-3">
                            @if(this.selectTaxAdminOptional.length != 0) {
                            <select class="form-select" formControlName="idFeeCodeOptional">
                                @for (taxOptional of this.selectTaxAdminOptional; track $index) {
                                <option [value]="taxOptional.idFeeCodeOptional">
                                    {{taxOptional.listOptionalAdministrativeFeetraduction[0].description}}
                                </option>
                                }
                            </select>
                            }@else {
                            <div class="alert alert-primary mt-2" role="alert">
                                <label class="form-label textformat">
                                    {{ 'tuition-calc.emptyListTaxOptional' | translate}}
                                </label>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- ## BLOQUE PARA LOS DESCUENTOS PROMOCIONALES -->
                    <!-- ########################################### -->
                    <div class="row" [hidden]="!isDiscountPromotional">
                        <div class="separator mt-5"></div>
                        <h2><label class="form-label textformat">{{
                                'tuition-calc.discountPromotional' | translate
                                }}</label>
                        </h2>
                        <!-- idDiscountPromotionalCode-->
                        <div class="col-auto mb-3">
                            @if(this.selectDiscountPromotional.length != 0) {
                            <select class="form-select" formControlName="idDiscountPromotionalCode">
                                @for (discPromotion of this.selectDiscountPromotional; track $index) {
                                <option [value]="discPromotion.idDiscountCode">
                                    {{discPromotion.listDiscountDescription[0].description}}
                                </option>
                                }
                            </select>
                            }@else {
                            <div class="alert alert-primary mt-2" role="alert">
                                <label class="form-label textformat">
                                    {{ 'tuition-calc.emptyListDiscoPromo' | translate}}
                                </label>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- ## BLOQUE PARA LOS DESCUENTOS SELECCIONABLES -->
                    <!-- ############################################ -->
                    <div class="row" [hidden]="!isSelectDiscountSelect">
                        <div class="row mb-5">
                            <div class="separator mt-5"></div>
                            <h2><label class="form-label textformat">{{
                                    'tuition-calc.listDiscountSelection' | translate
                                    }}</label>
                            </h2>
                            <div class="col-auto mb-3">
                                @if(this.selectDisctNoAcumulative.length != 0) {
                                <select class="form-select" formControlName="idDiscountCode">
                                    @for (discNoAcum of this.selectDisctNoAcumulative; track $index) {
                                    <option [value]="discNoAcum.idDiscountCode">
                                        {{discNoAcum.listDiscountDescription[0].description}}
                                    </option>
                                    }
                                </select>
                                }
                                @if(this.selectDisctAcumulative.length != 0) {
                                <h2><label class="form-label textformat mt-3">{{
                                        'tuition-calc.discounAcumlu' |
                                        translate
                                        }}</label>
                                </h2>
                                @for (discAcum of this.selectDisctAcumulative; track $index) {
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" [value]="discAcum.idDiscountCode"
                                        id="checkDefault">
                                    <label class="form-check-label" for="checkDefault">
                                        {{discAcum.listDiscountDescription[0].description}}
                                    </label>
                                </div>
                                }
                                }
                                @if(this.selectDisctNoAcumulative.length == 0 &&
                                this.selectDisctAcumulative.length == 0) {
                                <div class="alert alert-primary" role="alert">
                                    <label class="form-label textformat">
                                        {{ 'tuition-calc.emptyListDisc' | translate}}
                                    </label>
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
                <button type="submit" class="btn custombutton mt-3">{{'tuition-calc.send' | translate }}</button>
            </form>

            <!-- RESPUESTA CÁLCULO -->
            <!-- ################# -->
            @if(this.economicCalculationResponseDto !== undefined) {

            <div class="separator mt-5"></div>
            <div class="accordion mt-3" id="accordionExample">
                <div class="card">
                    <div class="card-header">
                        {{ 'tuition-calc.responseCalc' | translate }}
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                {{ 'tuition-calc.tuitionFeeSummary' | translate }}
                            </button>
                        </h2>

                        <div id="collapseOne" class="accordion-collapse collapse show"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row justify-content-center">
                                    <div class="col-md-10 col-lg-8">
                                        <div class="card">
                                            <div class="card-header bg-primary text-white text-center">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.dataEntry' | translate
                                                        }}</strong></h2>
                                            </div>
                                            <div class="card-body p-0">
                                                <ul class="list-group list-group-flush">
                                                    @for (field of [
                                                    {label: 'tuition-calc.extSystemCode', value:
                                                    economicCalculationResponseDto.externalSystemCode},
                                                    {label: 'tuition-calc.idUniqueTransactionExternalSystem', value:
                                                    economicCalculationResponseDto.idUniqueTransactionExternalSystem},
                                                    {label: 'tuition-calc.numberTimesModificationFeeAppliedAfter',
                                                    value:
                                                    economicCalculationResponseDto.numberTimesModificationFeeAppliedAfter},
                                                    {label: 'tuition-calc.numberTimesCancelationFeeApplied', value:
                                                    economicCalculationResponseDto.numberTimesCancelationFeeApplied},
                                                    {label: 'tuition-calc.rateModelCodeApplied', value:
                                                    economicCalculationResponseDto.dataEntry.rateModelCodeApplied},
                                                    {label: 'tuition-calc.companyPaymentPercentage', value:
                                                    economicCalculationResponseDto.dataEntry.companyPaymentPercentage},
                                                    {label: 'tuition-calc.companyFixedAmount', value:
                                                    economicCalculationResponseDto.dataEntry.companyFixedAmount},
                                                    {label: 'tuition-calc.selectedCofrosStudentPaymentMethodCode',
                                                    value:
                                                    economicCalculationResponseDto.dataEntry.selectedCofrosStudentPaymentMethodCode},
                                                    {label: 'tuition-calc.selectedCofrosCompanyPaymentMethodCode',
                                                    value:
                                                    economicCalculationResponseDto.dataEntry.selectedCofrosCompanyPaymentMethodCode},
                                                    {label: 'tuition-calc.behaviourPatternModificationCode', value:
                                                    economicCalculationResponseDto.dataEntry.behaviourPatternModificationCode}
                                                    ]; track $index) {
                                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                                        <span>{{ field.label | translate }}</span>
                                                        <span class="fw-semibold">{{ field.value }}</span>
                                                    </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- tuitionFeeSummary -->
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                {{ 'tuition-calc.generalGlobal' | translate }}
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3">

                                    <div class="col-md-12">
                                        <span>{{ 'launcher.currency-code' | translate
                                            }}: </span>
                                        <span class="fw-semibold badge bg-success fs-6"> {{
                                            economicCalculationResponseDto.tuitionFeeSummary.currencyCode }}</span>
                                    </div>

                                    <!-- General -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.general' | translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-tuitionfeesummary
                                                [tuitionFeeSummary]="economicCalculationResponseDto.tuitionFeeSummary"
                                                [isGeneral]="true"></app-tuitionfeesummary>
                                        </div>
                                    </div>

                                    <!-- Estudiante -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.generalStudent' | translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-tuitionfeesummary
                                                [tuitionFeeSummary]="economicCalculationResponseDto.tuitionFeeSummary"
                                                [isStudent]="true"></app-tuitionfeesummary>
                                        </div>
                                    </div>

                                    <!-- Compañía -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.generalCompany' | translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-tuitionfeesummary
                                                [tuitionFeeSummary]="economicCalculationResponseDto.tuitionFeeSummary"
                                                [isCompany]="true"></app-tuitionfeesummary>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- partialTuitionAmount -->
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                {{ 'tuition-calc.partialTuition' | translate }}
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3">

                                    <!-- partialTuitionAmount -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.partialGlobal' |
                                                        translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-partial-tuition-amount
                                                [partialTuitionAmount]="economicCalculationResponseDto.partialTuitionAmount"
                                                [isGeneral]="true"></app-partial-tuition-amount>
                                        </div>
                                    </div>

                                    <!-- partialTuitionAmountStudent -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.partialGlobalStudent' |
                                                        translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-partial-tuition-amount
                                                [partialTuitionAmount]="economicCalculationResponseDto.partialTuitionAmount"
                                                [isStudent]="true"></app-partial-tuition-amount>
                                        </div>
                                    </div>

                                    <!-- partialTuitionAmountCompany -->
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.partialGlobalCompany' |
                                                        translate
                                                        }}</strong></h2>
                                            </div>
                                            <app-partial-tuition-amount
                                                [partialTuitionAmount]="economicCalculationResponseDto.partialTuitionAmount"
                                                [isCompany]="true"></app-partial-tuition-amount>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- listSelectedProductsOfRegistration -->
                    @if(economicCalculationResponseDto.listSelectedProductsOfRegistration.length >= 1) {
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                {{ 'tuition-calc.programsAcademicAndLearning' | translate }}
                            </button>
                        </h2>

                        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3">
                                    <div class="col-md-4">
                                        <div class="card">
                                            @for (pr of
                                            economicCalculationResponseDto.listSelectedProductsOfRegistration;
                                            track $index) {
                                            <!-- Resumen total -->
                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0"><strong>{{
                                                        'tuition-calc.idProgram'
                                                        |
                                                        translate
                                                        }}</strong></h2>
                                            </div>
                                            <div class="card-body">
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                                        <span>{{
                                                            'tuition-calc.programId'
                                                            |
                                                            translate
                                                            }}</span>
                                                        <strong> {{pr.idProduct}} </strong>
                                                    </li>

                                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                                        <span>{{
                                                            'tuition-calc.totalAcademicAndLearningImport'
                                                            |
                                                            translate
                                                            }}</span>
                                                        <strong> {{pr.totalAcademicWithLearningResourceAmountExclVat}} €
                                                        </strong>
                                                    </li>

                                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                                        <span>{{
                                                            'tuition-calc.totalAcademicImport'
                                                            |
                                                            translate
                                                            }}</span>
                                                        <strong>
                                                            {{pr.totalAcademicWithLearningResourceAmountStudentExclVat}}
                                                            €
                                                        </strong>
                                                    </li>
                                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                                        <span>{{
                                                            'tuition-calc.totalLearningImport'
                                                            |
                                                            translate
                                                            }}</span>
                                                        <strong>
                                                            {{pr.totalAcademicWithLearningResourceAmountCompanyExclVat}}
                                                            €
                                                        </strong>
                                                    </li>
                                                </ul>
                                            </div>
                                            }
                                        </div>
                                    </div>

                                    <!-- ListSelectedProductsOfRegistration -->
                                    @for (pr of
                                    economicCalculationResponseDto.listSelectedProductsOfRegistration;
                                    track $index) {
                                    <!-- Academic -->
                                    <div class="col-md-4">
                                        @if(pr.listAppliedAcademicFee.length >= 1) {
                                        <div class="card h-100">
                                                @for (academic of pr.listAppliedAcademicFee; track
                                                academic.idTuitionFeeCode) {
                                                <app-generic-rate-list [titleTax]="'launcher.taxAcademic' | translate"
                                                    [idTaxGeneric]="academic.idTuitionFeeCode"
                                                    [listAppliedAcademicFee]="academic"
                                                    [listTraductionGeneric]="academic.listAppliedAcademicFeeTraductionDto"></app-generic-rate-list>
                                                }
                                        </div>
                                        }@else {
                                        <div class="card-header text-center bg-primary text-white">
                                            <h5 class="mb-0"><strong>{{'launcher.taxAcademic' | translate}}</strong>
                                            </h5>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="alert alert-primary mt-2" role="alert">
                                                    <label class="form-label textformat">
                                                        {{ 'tuition-calc.emptyListAcademic' | translate}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <!-- Learning -->
                                    <div class="col-md-4">
                                        @if(pr.listAppliedLearningResourceRate.length >= 1) {
                                        <div class="card h-100">
                                                @for (learning of pr.listAppliedLearningResourceRate; track
                                                learning.idLearningResourceRate) {
                                                <app-generic-rate-list
                                                    [titleTax]="'launcher.learningResource' | translate"
                                                    [idTaxGeneric]="learning.idLearningResourceRate"
                                                    [listAppliedLearningResourceRate]="learning"
                                                    [listTraductionGeneric]="learning.listAppliedLearningResourceTraduction"></app-generic-rate-list>
                                                }
                                        </div>
                                        }@else {
                                        <div class="card-header text-center bg-primary text-white">
                                            <h5 class="mb-0"><strong>{{'launcher.learningResource' |
                                                    translate}}</strong>
                                            </h5>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="alert alert-primary mt-2" role="alert">
                                                    <label class="form-label textformat">
                                                        {{ 'tuition-calc.emptyListLearning' | translate}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- listShippingRatesApplied -->
                    @if(economicCalculationResponseDto.listShippingRatesApplied.length >= 1 ) {
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                {{ 'tuition-calc.taxShipping' | translate }}
                            </button>
                        </h2>

                        <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3 d-flex justify-content-center">
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            @for (shipping of
                                            economicCalculationResponseDto.listShippingRatesApplied;
                                            track $index) {
                                            <app-generic-rate-list [titleTax]="'tuition-calc.shipping' | translate"
                                                [idTaxGeneric]="shipping.idShippingRateCode"
                                                [listShippingRatesApplied]="shipping"
                                                [listTraductionGeneric]="shipping.listShippingRatesAppliedTraduction"></app-generic-rate-list>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- listOptionalAdministrativeFeeApplied -->
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                {{ 'tuition-calc.taxAdminOptinal' | translate }}
                            </button>
                        </h2>

                        <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3 d-flex justify-content-center">
                                    @if(economicCalculationResponseDto.listOptionalAdministrativeFeeApplied.length
                                    >= 1 ) {
                                    @for (taxOptional of
                                    economicCalculationResponseDto.listOptionalAdministrativeFeeApplied;
                                    track $index) {
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <app-generic-rate-list [titleTax]="'tuition-calc.adminOptial' | translate"
                                                [idTaxGeneric]="taxOptional.idOptionalAdministrativeFeeCode"
                                                [listOptionalAdministrativeFeeApplied]="taxOptional"
                                                [listTraductionGeneric]="taxOptional.listOptionalAdministrativeFeeAppliedTraduction"></app-generic-rate-list>

                                        </div>
                                    </div>
                                    }
                                    }@else {
                                    <div class="alert alert-primary mt-2" role="alert">
                                        <label class="form-label textformat">
                                            {{ 'tuition-calc.emptyListTaxOptional' | translate}}
                                        </label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- listMandatoryAdministrativeFeeApplied -->
                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                {{ 'tuition-calc.taxAdminMandatory' | translate }}
                            </button>
                        </h2>

                        <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3 justify-content-center">
                                    @if(economicCalculationResponseDto.listMandatoryAdministrativeFeeApplied.length >=
                                    1) {
                                    @for (taxMandatory of
                                    economicCalculationResponseDto.listMandatoryAdministrativeFeeApplied;
                                    track $index) {
                                    <div class="col-md-4">
                                        <div class="card h-100">
                                            <app-generic-rate-list
                                                [titleTax]="'tuition-calc.adminMandatory' | translate"
                                                [idTaxGeneric]="taxMandatory.idMandatoryAdministrativeFeeCode"
                                                [listMandatoryAdministrativeFeeApplied]="taxMandatory"
                                                [administrativeModificationFeeIndicator]="taxMandatory.administrativeModificationFeeIndicator"
                                                [administrativeCancelationFeeIndicator]="taxMandatory.administrativeCancelationFeeIndicator"
                                                [listTraductionGeneric]="taxMandatory.listMandatoryAdministrativeFeeAppliedTraduction"></app-generic-rate-list>

                                        </div>
                                    </div>
                                    }
                                    }@else{
                                    <div class="alert alert-primary" role="alert">
                                        <label class="form-label textformat">
                                            {{ 'tuition-calc.emptyListTaxMandatory' | translate}}
                                        </label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- listSummaryOfAllAppliedDiscount -->

                    <div class="accordion-item">
                        <h2 class="accordion-header custombutton">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                {{ 'tuition-calc.discountGroup' | translate }}
                            </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div class="row g-3 justify-content-center">
                                    @if(economicCalculationResponseDto.listSummaryOfAllAppliedDiscount.length >= 1) {
                                    @for (listSummaryDiscount of
                                    economicCalculationResponseDto.listSummaryOfAllAppliedDiscount; track $index) {
                                    <div class="col-md-4">
                                        <div class="card h-100 shadow-sm rounded-3">

                                            <div class="card-header text-center bg-primary text-white">
                                                <h2 class="mb-0">
                                                    <strong>{{ 'launcher.idDiscount' | translate }}: #</strong> <span
                                                        class="fw-bold">{{
                                                        listSummaryDiscount.idDiscount }}</span>
                                                </h2>
                                            </div>

                                            <!-- Secciones de traducción -->
                                            <div class="card-body">
                                                <ng-container *ngFor="let section of [
            { title: 'tuition-calc.sensitiveData' | translate, list: listSummaryDiscount.listAllSensitiveData },
            { title: 'tuition-calc.description' | translate, list: listSummaryDiscount.listAllDescription }]">
                                                    <div *ngIf="section.list?.length">
                                                        <h6 class="mt-3">
                                                            <strong>{{ section.title }}</strong>
                                                        </h6>
                                                        <ul class="list-group list-group-flush">
                                                            <li class="list-group-item d-flex justify-content-between align-items-center py-1"
                                                                *ngFor="let dto of section.list">
                                                                <span class="text-muted">{{ dto.isoLanguageCode ==
                                                                    'es'
                                                                    ?
                                                                    'Español' :
                                                                    dto.isoLanguageCode == 'ca' ? 'Catalán' :
                                                                    'Inglés'
                                                                    }}</span>
                                                                <span>{{ dto.description == null ? 'Not description'
                                                                    : dto.description }}</span>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'tuition-calc.fixedDiscount' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.idStudentPersonalBonusTercer
                                                                    }}</strong>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'launcher.validationTercer' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.validDiscountIndicatorTercer
                                                                    }}</strong>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'launcher.validationManual' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.manualValidation
                                                                    == null ? 'null' :
                                                                    listSummaryDiscount.manualValidation
                                                                    }}</strong>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'tuition-calc.totalGeneralDiscountAmount' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.totalAmountOfDiscountApplied
                                                                    }}</strong>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'tuition-calc.totalStudentDiscountAmount' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.totalAmountOfDiscountAppliedStudent
                                                                    }}</strong>
                                                            </li>

                                                            <li
                                                                class="list-group-item py-2 d-flex justify-content-between">
                                                                <span>{{
                                                                    'tuition-calc.totalCompanyDiscountAmount' |
                                                                    translate }}</span>
                                                                <strong>{{
                                                                    listSummaryDiscount.totalAmountOfDiscountAppliedCompany
                                                                    }}</strong>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    }@else {
                                    <div class="alert alert-primary" role="alert">
                                        <label class="form-label textformat">
                                            {{ 'tuition-calc.emptyListDisc' | translate}}
                                        </label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            }
        </div>
    </main>
</div>

<!-- Spinner modal para el spinner -->
<app-spinner-modal [potential]="false"></app-spinner-modal>

<!-- Modal para el error -->
<app-error-modal [title]="errorTitle" [message]="errorMessage" [showErrorModal]="showErrorModal"
    (close)="onErrorModalClose()">
</app-error-modal>